'use client';

import { type JSX } from 'react';

import { useRecaptchaForm } from './RecaptchaFormContext';
import { RecaptchaV2Challenge } from './v2/RecaptchaV2Challenge';

/**
 * Renders the v2 checkbox challenge only when the enclosing <RecaptchaForm> has escalated from
 * invisible v3. Drop it into a form with no props; it reads visibility, resetKey, and onChange
 * from context. `className` forwards to the challenge wrapper for per-form layout.
 */
export function RecaptchaFormChallenge({ className }: { className?: string }): JSX.Element | null {
    const { v2Challenge } = useRecaptchaForm();
    if (!v2Challenge.visible) {
        return null;
    }
    // key={resetKey} remounts the checkbox for a fresh challenge after a failed v2 attempt.
    return <RecaptchaV2Challenge key={v2Challenge.resetKey} onChange={v2Challenge.onChange} className={className} />;
}
